import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import EditFreelancerUserHelper from '../EditFreelancerUserHelper';

export default class PaymentInformationForIndia {
  //#region Validation
  static validityCheckerForIndiaFields(e, editedItem) {
    if (editedItem.IsEmployee) return '';
    return ValidityHelper.forRequiredTextField(e);
  }
  //#endregion

  static returnDescriptionTab() {
    return {
      label: 'India Payment Information',
      hide: (item) => EditFreelancerUserHelper.isBillingDetailHidden(item, 5),
      fields: [
        {
          fieldName: 'PaymentCurrencyId',
          label: 'Payment Currency',
          className: 'col-6',
          type: InputTypesEnum.CurrencySelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'PaymentMethod',
          label: 'Payment Method',
          className: 'col-6',
          type: InputTypesEnum.Select,
          selectvalues: EditFreelancerUserHelper.getPaymentMethodSelectOptions,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'PIAccountHolderName',
          label: 'Account Holder Name',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: PaymentInformationForIndia.validityCheckerForIndiaFields,
        },
        {
          fieldName: 'PIBankName',
          label: 'Bank Name',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: PaymentInformationForIndia.validityCheckerForIndiaFields,
        },
        {
          fieldName: 'PIBranchNameOrId',
          label: 'Branch Name / ID',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: PaymentInformationForIndia.validityCheckerForIndiaFields,
        },
        {
          fieldName: 'PIBankAddress',
          label: 'Bank Address',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: PaymentInformationForIndia.validityCheckerForIndiaFields,
        },
        {
          fieldName: 'PIBankAccountNumber',
          label: 'Bank Account Number',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: PaymentInformationForIndia.validityCheckerForIndiaFields,
        },
        {
          fieldName: 'PISwiftIFSCCode',
          label: 'IFSC Code',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: PaymentInformationForIndia.validityCheckerForIndiaFields,
        },
        {
          fieldName: 'PIPanNo',
          label: 'PAN No.',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
      ],
    };
  }
}
